interface FetchStrapi {
  req: { url: string; populate?: string; params?: Record<string, string> }
  tags?: 'experts'[]
}

/**
 *
 * @param req
 * @param tags
 */
export const fetchStrapi = async <T>({ req }: FetchStrapi) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_PUBLIC_STRAPI_ENDPOINT}${req.url}?${req.populate ? req.populate : 'populate=*'}&${new URLSearchParams(req.params)}`,
      {
        headers: { Authorization: `Bearer ${import.meta.env.VITE_PUBLIC_STRAPI_TOKEN}` },
      },
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch strapi data: ${response.status} ${response.statusText}`)
    }

    return (await response.json()) as T
  } catch (err) {
    return null
  }
}
